import styles from './style.module.scss'
import React from 'react'

export const ItemData = ({ data }) => {
	return <div className={styles.item}>{data}</div>
}
